import { render, staticRenderFns } from "./CheckoutSummaryCard.vue?vue&type=template&id=0fdc923e&scoped=true&"
import script from "./CheckoutSummaryCard.vue?vue&type=script&lang=js&"
export * from "./CheckoutSummaryCard.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutSummaryCard.vue?vue&type=style&index=0&id=0fdc923e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdc923e",
  null
  
)

export default component.exports